'use strict';

var _toArray = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/toArray");

var promisify = require('promisify-es6');

var map = require('async/map');

var isIpfs = require('is-ipfs');

var CID = require('cids');

var ERR_BAD_PATH = 'ERR_BAD_PATH';
exports.OFFLINE_ERROR = 'This command must be run in online mode. Try running \'ipfs daemon\' first.';
/**
 * Break an ipfs-path down into it's hash and an array of links.
 *
 * examples:
 *  b58Hash -> { hash: 'b58Hash', links: [] }
 *  b58Hash/mercury/venus -> { hash: 'b58Hash', links: ['mercury', 'venus']}
 *  /ipfs/b58Hash/links/by/name -> { hash: 'b58Hash', links: ['links', 'by', 'name'] }
 *
 * @param  {String} ipfsPath An ipfs-path
 * @return {Object}            { hash: base58 string, links: [string], ?err: Error }
 * @throws on an invalid @param ipfsPath
 */

function parseIpfsPath(ipfsPath) {
  var invalidPathErr = new Error('invalid ipfs ref path');
  ipfsPath = ipfsPath.replace(/^\/ipfs\//, '');
  var matched = ipfsPath.match(/([^/]+(?:\/[^/]+)*)\/?$/);

  if (!matched) {
    throw invalidPathErr;
  }

  var _matched$1$split = matched[1].split('/'),
      _matched$1$split2 = _toArray(_matched$1$split),
      hash = _matched$1$split2[0],
      links = _matched$1$split2.slice(1); // check that a CID can be constructed with the hash


  if (isIpfs.cid(hash)) {
    return {
      hash: hash,
      links: links
    };
  } else {
    throw invalidPathErr;
  }
}
/**
 * Returns a well-formed ipfs Path.
 * The returned path will always be prefixed with /ipfs/ or /ipns/.
 * If the received string is not a valid ipfs path, an error will be returned
 * examples:
 *  b58Hash -> { hash: 'b58Hash', links: [] }
 *  b58Hash/mercury/venus -> { hash: 'b58Hash', links: ['mercury', 'venus']}
 *  /ipfs/b58Hash/links/by/name -> { hash: 'b58Hash', links: ['links', 'by', 'name'] }
 *
 * @param  {String} pathStr An ipfs-path, or ipns-path or a cid
 * @return {String} ipfs-path or ipns-path
 * @throws on an invalid @param ipfsPath
 */


var normalizePath = function normalizePath(pathStr) {
  if (isIpfs.cid(pathStr)) {
    return "/ipfs/".concat(pathStr);
  } else if (isIpfs.path(pathStr)) {
    return pathStr;
  } else {
    throw Object.assign(new Error("invalid ".concat(pathStr, " path")), {
      code: ERR_BAD_PATH
    });
  }
};
/**
 * Resolve various styles of an ipfs-path to the hash of the target node.
 * Follows links in the path.
 *
 * Accepts formats:
 *  - <base58 string>
 *  - <base58 string>/link/to/venus
 *  - /ipfs/<base58 string>/link/to/pluto
 *  - multihash Buffer
 *  - Arrays of the above
 *
 * @param  {IPFS}               objectAPI The IPFS object api
 * @param  {Described above}    ipfsPaths A single or collection of ipfs-paths
 * @param  {Function<err, res>} callback res is Array<Buffer(hash)>
 *                              if no callback is passed, returns a Promise
 * @return {Promise|void}
 */


var resolvePath = promisify(function (objectAPI, ipfsPaths, callback) {
  if (!Array.isArray(ipfsPaths)) {
    ipfsPaths = [ipfsPaths];
  }

  map(ipfsPaths, function (path, cb) {
    if (typeof path !== 'string') {
      var cid;

      try {
        cid = new CID(path);
      } catch (err) {
        return cb(err);
      }

      return cb(null, cid.buffer);
    }

    var parsedPath;

    try {
      parsedPath = exports.parseIpfsPath(path);
    } catch (err) {
      return cb(err);
    }

    var rootHash = new CID(parsedPath.hash);
    var rootLinks = parsedPath.links;

    if (!rootLinks.length) {
      return cb(null, rootHash.buffer);
    }

    objectAPI.get(rootHash.multihash, follow.bind(null, rootLinks)); // recursively follow named links to the target node

    function follow(links, err, obj) {
      if (err) {
        return cb(err);
      }

      if (!links.length) {
        // done tracing, obj is the target node
        return cb(null, obj.multihash);
      }

      var linkName = links[0];
      var nextObj = obj.links.find(function (link) {
        return link.name === linkName;
      });

      if (!nextObj) {
        return cb(new Error("no link named \"".concat(linkName, "\" under ").concat(obj.toJSON().multihash)));
      }

      objectAPI.get(nextObj.multihash, follow.bind(null, links.slice(1)));
    }
  }, callback);
});
/**
 * Parses chunker string into options used by DAGBuilder in ipfs-unixfs-engine
 *
 *
 * @param  {String}   chunker Chunker algorithm supported formats:
 *                    "size-{size}"
 *                    "rabin"
 *                    "rabin-{avg}"
 *                    "rabin-{min}-{avg}-{max}"
 *
 * @return {Object}   Chunker options for DAGBuilder
 */

function parseChunkerString(chunker) {
  if (!chunker) {
    return {
      chunker: 'fixed'
    };
  } else if (chunker.startsWith('size-')) {
    var sizeStr = chunker.split('-')[1];
    var size = parseInt(sizeStr);

    if (isNaN(size)) {
      throw new Error('Chunker parameter size must be an integer');
    }

    return {
      chunker: 'fixed',
      chunkerOptions: {
        maxChunkSize: size
      }
    };
  } else if (chunker.startsWith('rabin')) {
    return {
      chunker: 'rabin',
      chunkerOptions: parseRabinString(chunker)
    };
  } else {
    throw new Error("Unrecognized chunker option: ".concat(chunker));
  }
}
/**
 * Parses rabin chunker string
 *
 * @param  {String}   chunker Chunker algorithm supported formats:
 *                            "rabin"
 *                            "rabin-{avg}"
 *                            "rabin-{min}-{avg}-{max}"
 *
 * @return {Object}   rabin chunker options
 */


function parseRabinString(chunker) {
  var options = {};
  var parts = chunker.split('-');

  switch (parts.length) {
    case 1:
      options.avgChunkSize = 262144;
      break;

    case 2:
      options.avgChunkSize = parseChunkSize(parts[1], 'avg');
      break;

    case 4:
      options.minChunkSize = parseChunkSize(parts[1], 'min');
      options.avgChunkSize = parseChunkSize(parts[2], 'avg');
      options.maxChunkSize = parseChunkSize(parts[3], 'max');
      break;

    default:
      throw new Error('Incorrect chunker format (expected "rabin" "rabin-[avg]" or "rabin-[min]-[avg]-[max]"');
  }

  return options;
}

function parseChunkSize(str, name) {
  var size = parseInt(str);

  if (isNaN(size)) {
    throw new Error("Chunker parameter ".concat(name, " must be an integer"));
  }

  return size;
}

exports.normalizePath = normalizePath;
exports.parseIpfsPath = parseIpfsPath;
exports.resolvePath = resolvePath;
exports.parseChunkerString = parseChunkerString;